export const TUTORIAL_STEPS = [
  {
    id: 'tracker-table',
    title: 'Application Tracker',
    description:
      'Keep track of all your internship applications in one place. View your application statuses and history at a glance.',
    placement: 'right',
    image: '/maincar.png',
  },
  {
    id: 'add-application',
    title: 'Add Applications',
    description:
      "Click here to manually add applications you've submitted. You can also connect your email to automatically track applications!",
    placement: 'left',
    image: '/thinkingcar.png',
  },
  {
    id: 'email-access',
    title: 'Automatic Tracking',
    description:
      "Optionally connect your email to automatically track your applications. We'll scan your inbox for application-related emails and update your status automatically.",
    placement: 'top',
    image: '/maincar.png',
  },
];
